"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var gridTheme_1 = __importDefault(require("./gridTheme"));
var createColorStyles_1 = __importDefault(require("./utils/createColorStyles"));
exports.createMediaQuery = function (n) {
    return "@media screen and (min-width:" + n + "px)";
};
var addAliases = function (arr, aliases) {
    return aliases.forEach(function (key, i) {
        return Object.defineProperty(arr, key, {
            enumerable: false,
            get: function () {
                return this[i];
            }
        });
    });
};
exports.breakpoints = [
    gridTheme_1["default"].breakpoints.sm,
    gridTheme_1["default"].breakpoints.md,
    gridTheme_1["default"].breakpoints.lg,
    gridTheme_1["default"].breakpoints.xl,
    gridTheme_1["default"].breakpoints.xxl,
];
exports.mediaQueries = exports.breakpoints.map(exports.createMediaQuery);
// breakpoints
var aliases = [
    'sm',
    'md',
    'lg',
    'xl',
    'xxl',
];
addAliases(exports.breakpoints, aliases);
addAliases(exports.mediaQueries, aliases);
exports.space = [0, 4, 8, 16, 32, 64, 128];
var spaceAliases = [
    'none',
    'xxs',
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
];
addAliases(exports.space, spaceAliases);
exports.headingFont = "'Encode Sans',sans-serif";
exports.textFont = "'Encode Sans',sans-serif";
exports.fontSizes = [12, 14, 16, 20, 24, 32, 38, 40, 48, 56, 72];
exports.light = 300;
exports.normal = 400;
exports.bold = 600;
exports.bolder = 700;
// styled-system's `fontWeight` function can hook into the `fontWeights` object
exports.fontWeights = {
    light: exports.light,
    normal: exports.normal,
    bold: exports.bold,
    bolder: exports.bolder
};
exports.lineHeights = {
    standard: 1.5,
    display: 1.25
};
var letterSpacings = {
    normal: 'normal',
    caps: '0.025em'
};
// color palette
var alertBlue = '#cce5ff';
var alertBlueText = '#004085';
var alertGreen = '#e3fcef';
var alertGreenText = '#177f4b';
var alertRed = '#ffebe6';
var alertRedText = '#cb023c';
var alertYellow = '#fffae6';
var alertYellowText = '#ad5f00';
var black = '#070707';
var white = '#fff';
var lighterBlue = '#f9fdff';
var lightBlue = '#158AE0';
var blue = '#0379CE';
var darkBlue = '#03275B';
var steelBlue = '#527B89';
var orange = '#f26522';
var lightGray = '#f3f3f3';
var borderGray = '#d5dfe6';
var gray = '#626568';
var darkGray = '#404041';
var green = '#0A8562';
var red = '#EB003B';
var yellow = '#F8E71C';
var purple = '#8A60CD';
var transparent = '#00000000';
var eggshellBlue = '#c6fdf2';
var peachOrange = '#ffcf9a';
// color alias
var primary = blue;
var secondary = darkBlue;
var tertiary = orange;
var text = black;
var primaryText = white;
exports.colors = {
    alertBlue: alertBlue,
    alertBlueText: alertBlueText,
    alertGreen: alertGreen,
    alertGreenText: alertGreenText,
    alertRed: alertRed,
    alertRedText: alertRedText,
    alertYellow: alertYellow,
    alertYellowText: alertYellowText,
    black: black,
    white: white,
    lighterBlue: lighterBlue,
    lightBlue: lightBlue,
    blue: blue,
    darkBlue: darkBlue,
    steelBlue: steelBlue,
    orange: orange,
    lightGray: lightGray,
    borderGray: borderGray,
    gray: gray,
    darkGray: darkGray,
    green: green,
    red: red,
    primary: primary,
    secondary: secondary,
    tertiary: tertiary,
    text: text,
    primaryText: primaryText,
    transparent: transparent,
    yellow: yellow,
    purple: purple,
    eggshellBlue: eggshellBlue,
    peachOrange: peachOrange
};
// color styles
exports.colorStyles = createColorStyles_1["default"]({ colors: exports.colors });
// styled-system's `borderRadius` function can hook into the `radii` object/array
exports.radii = [0, 4, 8];
exports.radius = '4px';
exports.maxContainerWidth = '1280px';
// boxShadows
exports.boxShadows = [
    "0 0 2px 0 rgba(0,0,0,.08),0 1px 4px 0 rgba(0,0,0,.16)",
    "0 0 2px 0 rgba(0,0,0,.08),0 2px 8px 0 rgba(0,0,0,.16)",
    "0 0 2px 0 rgba(0,0,0,.08),0 4px 16px 0 rgba(0,0,0,.16)",
    "0 0 2px 0 rgba(0,0,0,.08),0 8px 32px 0 rgba(0,0,0,.16)",
];
// animation easing curves
var easeInOut = 'cubic-bezier(0.5, 0, 0.25, 1)';
var easeOut = 'cubic-bezier(0, 0, 0.25, 1)';
var easeIn = 'cubic-bezier(0.5, 0, 1, 1)';
var timingFunctions = {
    easeInOut: easeInOut,
    easeOut: easeOut,
    easeIn: easeIn
};
// animation duration
exports.duration = {
    fast: "150ms",
    normal: "300ms",
    slow: "450ms",
    slowest: "600ms"
};
// animation delay
var transitionDelays = {
    small: "60ms",
    medium: "160ms",
    large: "260ms",
    xLarge: "360ms"
};
var padding = {
    small: '5px',
    medium: '15px',
    large: '25px',
    xLarge: '45px'
};
var margin = {
    small: '5px',
    medium: '15px',
    large: '25px'
};
var shared = {
    breakpoints: exports.breakpoints,
    mediaQueries: exports.mediaQueries,
    space: exports.space,
    headingFont: exports.headingFont,
    textFont: exports.textFont,
    fontSizes: exports.fontSizes,
    fontWeights: exports.fontWeights,
    lineHeights: exports.lineHeights,
    letterSpacings: letterSpacings,
    colors: exports.colors,
    colorStyles: exports.colorStyles,
    primary: primary,
    secondary: secondary,
    tertiary: tertiary,
    text: text,
    radii: exports.radii,
    radius: exports.radius,
    boxShadows: exports.boxShadows,
    maxContainerWidth: exports.maxContainerWidth,
    timingFunctions: timingFunctions,
    duration: exports.duration,
    transitionDelays: transitionDelays,
    padding: padding,
    margin: margin
};
// do not set a type (like DefaultTheme), because styled-system uses additional keys not in the DefaultTheme
var lightTheme = __assign(__assign({ light: true }, shared), { foreground: primary, background: white });
exports["default"] = lightTheme;
//# sourceMappingURL=theme.js.map